module.exports = __webpack_public_path__ + "img/Vector 52.dcb1bda4.png";